import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const MoreIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg
  style={{ transform: 'rotate(90deg)'}}
    className={'moreIcon'}
    width="32"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10Z"
        fill={fill}
    />
  </svg>
);

export default MoreIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const MoreIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg
  style={{ transform: 'rotate(90deg)'}}
    className={'moreIcon'}
    width="32"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10Z"
        fill={fill}
    />
  </svg>
);

export default MoreIcon;
